import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { PermissionVerb } from '@s8l/client-tree-lib';

export interface PermissionToggleConfig {
  all: number | PermissionVerb;
  any: number | PermissionVerb;
  rec?: boolean; // recursive for nodes
  chl?: boolean; // do children actually exist
  chlAll?: number | PermissionVerb;
  chlAny?: number | PermissionVerb;
  chlKnown?: boolean; // whether chlAll/chlAny were computed from actually-loaded children
  protect?: boolean;
}

export interface Flags {
  r: boolean;
  w: boolean;
  d: boolean;
}

@Component({
  selector: 'app-permission-toggles',
  templateUrl: './permission-toggles.component.html',
  styleUrls: ['./permission-toggles.component.scss']
})
export class PermissionTogglesComponent implements OnInit {
  // Make enum available in template
  public readonly PermissionVerb = PermissionVerb;

  // Template for permission toggles
  @ViewChild('template', { static: true }) template;

  @Input() public disabled = false;

  @Input() public set config(c: PermissionToggleConfig) {
    this.all = PermissionTogglesComponent.rwdOf(c.all);
    this.any = PermissionTogglesComponent.rwdOf(c.any);
    this.chlAll = PermissionTogglesComponent.rwdOf(c.chlAll);
    this.chlAny = PermissionTogglesComponent.rwdOf(c.chlAny);
    this.rec = c.rec ?? false;
    this.chl = c.chl ?? false;
    this.chlKnown = c.chlKnown ?? false;
    this.protect = c.protect ?? false;
  }

  @Output() public change = new EventEmitter<{ verb: PermissionVerb; state: boolean; recursive: boolean }>();

  public all: Flags;
  public any: Flags;
  public rec: boolean;
  public chl: boolean;
  public chlAll: Flags;
  public chlAny: Flags;
  public chlKnown: boolean;
  public protect: boolean;

  constructor(private viewContainerRef: ViewContainerRef) {}

  public ngOnInit(): void {
    // Setup table cells so that the content is moved out of the angular wrapper
    this.viewContainerRef?.createEmbeddedView(this.template);
    // Additional hack to remove wrapping component completly
    // this.viewContainerRef.element.nativeElement.remove();
  }

  private static rwdOf(flags: number | PermissionVerb): Flags {
    const r = (flags & PermissionVerb.Read) == PermissionVerb.Read;
    const w = (flags & PermissionVerb.Write) == PermissionVerb.Write;
    const d = (flags & PermissionVerb.Delete) == PermissionVerb.Delete;
    return { r, w, d };
  }
}
